import React from 'react';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import CushionSvg from '../../../../assets/img/cushion.svg';
import EmeraldSvg from '../../../../assets/img/emerald.svg';
import HeartSvg from '../../../../assets/img/heart.svg';
import HexagonalSvg from '../../../../assets/img/hexagonal.svg';
import KiteSvg from '../../../../assets/img/kite.svg';
import MarquiseSvg from '../../../../assets/img/mariquise.svg';
import OctagonalSvg from '../../../../assets/img/octagonal.svg';
import OtherSvg from '../../../../assets/img/other.svg';
import OvalSvg from '../../../../assets/img/oval.svg';
import PearSvg from '../../../../assets/img/pear.svg';
import RadiantSvg from '../../../../assets/img/radiant.svg';
import RoundSvg from '../../../../assets/img/round.svg';
import SquareSvg from '../../../../assets/img/suqare.svg';
import TriangularSvg from '../../../../assets/img/triangular.svg';
import TriliantSvg from '../../../../assets/img/trilliant.svg';
import { CustomButton } from './GemFilterModal';
import { GemFeature } from '../../../../utils/enums/gem-feature.enum';
import { GemShape } from '../../../../utils/enums/gem-shape.enum';

const shapes = [
  {
    icon: OvalSvg,
    name: GemShape.Oval,
  },
  {
    icon: RoundSvg,
    name: GemShape.Round,
  },
  {
    icon: EmeraldSvg,
    name: GemShape.Emerald,
  },
  {
    icon: PearSvg,
    name: GemShape.Pear,
  },
  {
    icon: OctagonalSvg,
    name: GemShape.Octagonal,
  },
  {
    icon: SquareSvg,
    name: GemShape.Square,
  },
  {
    icon: MarquiseSvg,
    name: GemShape.Marquise,
  },
  {
    icon: HeartSvg,
    name: GemShape.Heart,
  },
  {
    icon: TriangularSvg,
    name: GemShape.Triangular,
  },
  {
    icon: RadiantSvg,
    name: GemShape.Radiant,
  },
  {
    icon: KiteSvg,
    name: GemShape.Kite,
  },
  {
    icon: CushionSvg,
    name: GemShape.Cushion,
  },
  {
    icon: TriliantSvg,
    name: GemShape.Trilliant,
  },
  {
    icon: HexagonalSvg,
    name: GemShape.Hexagonal,
  },
  {
    icon: OtherSvg,
    name: GemShape.Other,
  },
];

interface IShapesProps {
  handleSelectOption: (_gemFeature: GemFeature, _value: string) => void;
  isSelected: (_gemFeature: GemFeature, _value: string) => boolean;
}

function Shapes({ handleSelectOption, isSelected }: IShapesProps) {
  return shapes.map((shape) => (
    <CustomButton
      key={shape.name}
      variant="outlined"
      onClick={() => handleSelectOption(GemFeature.SHAPE, shape.name)}
      selected={isSelected(GemFeature.SHAPE, shape.name)}
      sx={{ width: '107px', height: '88px' }}
    >
      <Grid display="flex" flexDirection="column" gap={1.5}>
        <Box component="img" src={shape.icon} height={40} />

        <Typography variant="textBase500">{shape.name}</Typography>
      </Grid>
    </CustomButton>
  ));
}

export default Shapes;
